export abstract class UserKey {
  static CURRENT_USER = ['current-user'];
  static CURRENT_USER_LINK_ACCOUNT = [...UserKey.CURRENT_USER, 'link-account'];
}
